"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AuthContainer;
var _react = _interopRequireDefault(require("react"));
var Icons = _interopRequireWildcard(require("../Icons"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function AuthContainer(_ref) {
  var children = _ref.children,
    title = _ref.title,
    subtitle = _ref.subtitle,
    loading = _ref.loading,
    error = _ref.error;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-login"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, loading && !error ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Logo, {
    className: "page-login-scaling",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6 text-center"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-white"
  }, "Cargando...")))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-11 col-sm-10 col-md-6 col-lg-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-login-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-center page-login-form-top"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col d-flex justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-login-logo"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Logo, null)))), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-center sub text-uppercase"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center"
  }, subtitle), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children)))))));
}